import {
  IStagedFileGroup,
  IStagingDeleteRequest,
  IStagingStatus,
} from '@topshots/core-models';
import { topshotsAPI } from '../../app/api';

const stagingApi = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    getStagingStatus: build.query<IStagingStatus, void>({
      query: () => ({
        url: 'staging/status',
        method: 'GET',
      }),
      providesTags: ['Staging'],
    }),
    getStagingFiles: build.query<IStagedFileGroup[], void>({
      query: () => ({
        url: 'staging/files',
        method: 'GET',
      }),
      providesTags: ['Staging'],
    }),
    getStagingDownloadUrl: build.query<
      { url: string },
      { filename: string; userId: string }
    >({
      query: ({ filename, userId }) => ({
        url: `staging/download-url/${encodeURIComponent(filename)}`,
        method: 'GET',
        params: { userId },
      }),
    }),
    deleteStagingFiles: build.mutation<
      { deleted: number },
      IStagingDeleteRequest
    >({
      query: (data) => ({
        url: 'staging/files',
        method: 'DELETE',
        body: data,
      }),
      invalidatesTags: ['Staging'],
    }),
  }),
});

export const {
  useGetStagingStatusQuery,
  useGetStagingFilesQuery,
  useLazyGetStagingDownloadUrlQuery,
  useDeleteStagingFilesMutation,
} = stagingApi;
